import React, {useState} from 'react'

import Stack from "@mui/material/Stack";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import {TabContext} from "@mui/lab";


const days = [
    {attributeName: "monday", label: "L"},
    {attributeName: "tuesday", label: "M"},
    {attributeName: "wednesday", label: "M"},
    {attributeName: "thursday", label: "G"},
    {attributeName: "friday", label: "V"},
    {attributeName: "saturday", label: "S"},
    {attributeName: "sunday", label: "D"},
];

const TAB_HIGH = "highSeason";
const TAB_MIDDLE = "midSeason";
const TAB_LOW = "lowSeason";


const tabs = [
    {value: TAB_HIGH, label: 'Alta Stagione'},
    {value: TAB_MIDDLE, label: 'Media Stagione'},
    {value: TAB_LOW, label: 'Bassa Stagione'},
]

const SettingsPanel = ({formik}) => {
    const [tabValue, setTabValue] = useState(TAB_HIGH);
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return <TabContext value={tabValue}>
        <Stack spacing={2} height="550px">
            <TabHeader tabValue={tabValue} handleTabChange={handleTabChange}/>
            <TabPanel value={TAB_HIGH} sx={{p: 0}}>
                <SeasonConditions formik={formik} season={TAB_HIGH}/>
            </TabPanel>
            <TabPanel value={TAB_MIDDLE} sx={{p: 0}}>
                <SeasonConditions formik={formik} season={TAB_MIDDLE}/>
            </TabPanel>
            <TabPanel value={TAB_LOW} sx={{p: 0}}>
                <SeasonConditions formik={formik} season={TAB_LOW}/>
            </TabPanel>
        </Stack>
    </TabContext>
}

const TabHeader = ({tabValue, handleTabChange}) => {
    return <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="rate tabs" variant="fullWidth">
            {
                tabs.map((tab) => <Tab key={tab.value}
                                       value={tab.value}
                                       label={tab.label}
                />)
            }
        </Tabs>
    </Box>
}

const SeasonConditions = ({formik, season}) => {
    const seasonText = season === TAB_HIGH ? "Alta Stagione" : season === TAB_MIDDLE ? "Media Stagione" : "Bassa Stagione";

    return <Stack spacing={4}>
        <Typography textAlign="justify">
            Seleziona le condizioni di pernottamento in <Typography fontWeight={500} component="span">{seasonText}</Typography>.
        </Typography>

        <Stack direction="row" spacing={2} mt={2}>
            <TextField type="number"
                       label="Numero minimo notti"
                       fullWidth
                       name={`${season}[minNights]`}
                       required
                       value={formik.values[season].minNights || ""}
                       onChange={formik.handleChange}
                       error={Boolean(formik.errors[season]?.minNights)}
                       helperText={formik.errors[season]?.minNights}/>

            <TextField type="number"
                       label="Numero minimo persone"
                       fullWidth
                       name={`${season}[minPeople]`}
                       required
                       value={formik.values[season].minPeople || ""}
                       onChange={formik.handleChange}
                       error={Boolean(formik.errors[season]?.minPeople)}
                       helperText={formik.errors[season]?.minPeople}/>
        </Stack>

        <Typography>
            Giorni di arrivo:
        </Typography>
        <Stack direction="row" justifyContent="space-evenly">
            {
                days.map(day => (
                    <FormControlLabel
                        key={day.attributeName}
                        control={
                            <Checkbox
                                name={`${season}[checkin[${day.attributeName}]]`}
                                color="primary"
                                checked={!!formik.values[season].checkin[day.attributeName]}
                                onChange={(e) => {
                                    // cannot use formik.handleChange because it does not work as expected with indeterminate
                                    formik.setFieldValue(`${season}[checkin[${day.attributeName}]]`, e.target.checked)
                                }}
                            />
                        }
                        label={day.label}
                        labelPlacement="top"
                        sx={{margin: 0}}
                    />
                ))
            }
        </Stack>

        <Typography>
            Giorni di partenza:
        </Typography>
        <Stack direction="row" justifyContent="space-evenly">
            {
                days.map(day => (
                    <FormControlLabel
                        key={day.attributeName}
                        control={
                            <Checkbox
                                name={`${season}[checkout[${day.attributeName}]]`}
                                color="primary"
                                checked={!!formik.values[season].checkout[day.attributeName]}
                                onChange={(e) => {
                                    // cannot use formik.handleChange because it does not work as expected with indeterminate
                                    formik.setFieldValue(`${season}[checkout[${day.attributeName}]]`, e.target.checked)
                                }}
                            />
                        }
                        label={day.label}
                        labelPlacement="top"
                        sx={{margin: 0}}
                    />
                ))
            }
        </Stack>
    </Stack>
}
export default SettingsPanel